import Raven from 'raven-js';
import { Component } from 'react';
import FormattedCard from 'crm-cards-sdk/components/FormattedCard';
import { Metrics } from './Metrics';
import CardErrorMessage from 'crm-cards-sdk/components/CardErrorMessage';
import { CardContainerContext } from 'crm-cards-sdk/internal/CardContainerContext';
import { withCardErrorMarker } from 'crm-cards-sdk/internal/perf/cardPerfHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class CardErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: undefined
    };
  } // @ts-expect-error Typescript doesn't work too well with Context and Class Components
  // I need to set the type of this context value and this seems to be the cleanest way to do it
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error(error);
    Metrics.counter('card-errors', Object.assign({
      card_type: this.props.cardData.definition.cardType,
      location: this.props.location
    }, this.props.loggingTag ? {
      logging_tag: this.props.loggingTag
    } : {})).increment();
    Raven.captureException(error, {
      extra: {
        location: this.props.location,
        loggingTag: this.props.loggingTag,
        cardData: this.props.cardData,
        errorInfo
      }
    });
  }
  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return /*#__PURE__*/_jsxs(FormattedCard, {
      cardData: this.props.cardData,
      CardFormatter: this.context.DefaultCardFormatter,
      children: [/*#__PURE__*/_jsx(this.props.ErrorMarker, {}), /*#__PURE__*/_jsx(CardErrorMessage, {})]
    });
  }
}
CardErrorBoundary.contextType = CardContainerContext;
export default withCardErrorMarker(CardErrorBoundary, 'CARD_WRAPPER_ERROR_BOUNDARY');